import CreatorBackground from "assets/background/creatorBackground.webp";
import CalcBackground from "assets/background/calcBackground.webp";
import ContactBackground from "assets/background/contact.webp";

const styles = (theme) => ({
	title: {
		marginBottom: 0,
		fontSize: "clamp(24px, 3.5vw, 36px)",
		fontWeight: 400,
	},
	subTitle: {
		fontSize: "clamp(18px, 2.4vw, 24px)",
		color: "grey",
		fontWeight: 100,
	},
	desc: {
		maxWidth: 800,
		width: "100%",
		textAlign: "center",
		fontSize: "clamp(16px, 2vw, 18px)",
		color: "#4A4A4A",
		fontWeight: 100,
	},
	homeSection: {
		height: "70vh",
	},
	homeTitlePC: {
		position: "absolute",
		top: "30%",
		left: "40%",
		color: "white",
	},
	homeTitleMB: {
		paddingTop: "clamp(50px, 55%, 200px)",
		color: "white",
	},
	productSection: {
		background: "linear-gradient(rgba(255,255,255,1), rgba(207,5,5,0.2))",
		paddingTop: 100,
	},
	productionText: {
		paddingTop: "45%",
		color: "white",
		textShadow: "1px 1px 2px black",
		fontSize: "clamp(24px, 2.4vw, 35px)",
		fontWeight: 900,
	},
	productHover: {
		position: "absolute",
		cursor: "pointer",
		top: 0,
		left: 0,
		width: "100%",
		height: "99%",
		"&:hover": {
			backgroundColor: "rgba(0, 0, 0, 0.3);",
		},
	},
	productGradient: {
		background:
			"linear-gradient(45deg, rgba(246,90,159,0.9) 0%, rgba(255,190,113,0.85) 54%, rgba(246,90,90,0.7) 100%)",
	},
	image: {
		width: "100%",
	},
	opSection: {
		position: "relative",
		paddingTop: 72,
		paddingBottom: 72,
	},
	opTitlePos: {
		top: "10%",
		left: "15%",
		color: "#4A4A4A",
		fontWeight: 100,
	},
	opMainPos: {
		position: "absolute",
		top: "40%",
	},
	creatorSection: {
		position: "relative",
		background: `url(${CreatorBackground}) no-repeat center center fixed`,
		WebkitBackgroundSize: "cover",
		MozBackgroundSize: "cover",
		backgroundSize: "cover",
	},
	calcSection: {
		position: "relative",
		background: `url(${CalcBackground}) no-repeat center center fixed`,
		WebkitBackgroundSize: "cover",
		MozBackgroundSize: "cover",
		backgroundSize: "cover",
	},
	aboutSection: {},
	contactSection: {
		position: "relative",
		background: `url(${ContactBackground}) no-repeat center center fixed`,
		WebkitBackgroundSize: "cover",
		MozBackgroundSize: "cover",
		backgroundSize: "cover",
		paddingTop: 96,
		paddingBottom: 96,
	},
	mapSection: {
		paddingTop: 96,
		background: "white",
		paddingBottom: 96,
	},
	contactDesc: {
		fontSize: "clamp(16px, 2vw, 24px)",
		fontWeight: 900,
		color: "white",
		display: "flex",
		justifyContent: "center",
		flexDirection: "column",
		textAlign: "center",
	},
	contactContainer: {
		width: "100%",
		maxWidth: 600,
	},
	inputField: {
		backgroundColor: "white",
		width: "100%",
		marginTop: 16,
	},
	map: {
		width: "100%",
		maxWidth: 800,
	},
	footerSection: {
		background:
			"linear-gradient(to right, rgba(219,136,209,0.8), rgba(176,255,2555,0.5))",
	},
	toolTipStyle: {
		width: 600,
		fontSize: 18,
		lineHeight: 1.2,
		padding: 12,
	},
	toolTipLight: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
	},
	arrow: {
		color: theme.palette.common.white,
		fontSize: 16,
		width: 17,
		"&::before": {
			backgroundColor: "#fff",
			boxShadow: theme.shadows[1],
		},
	},
	noMaxWidth: {
		maxWidth: "none",
	},
});

export default styles;
